import React from "react";
import { FormattedMessage } from "react-intl";
import { useTheme } from "@mui/styles";
import { alpha, Grid, Pagination, PaginationItem } from "@mui/material";

export default function CommonTotalPagesCount({ state, clientportal, onChangePaginate }) {
  const theme = useTheme();
  const colorMain = clientportal.defaultcolor || theme.palette.primary.main;

  return (
    <React.Fragment>
      <Grid item xs={12} md={3}>
        <Pagination
          count={state.totalPages}
          page={state.page}
          onChange={onChangePaginate}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              sx={{
                color: `${colorMain} !important`,
                "& .MuiSvgIcon-root": {
                  color: `${colorMain} !important`,
                },
                "&.Mui-selected": {
                  backgroundColor: `${colorMain} !important`,
                  borderColor: `${colorMain} !important`,
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: `${alpha(colorMain, 0.6)} !important`,
                    borderColor: `${alpha(colorMain, 0.6)} !important`,
                  },
                },
              }}
            />
          )}
        />
      </Grid>

      <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
        {state.pageStart} <FormattedMessage id="to" /> {state.pageEnd}{" "}
        <FormattedMessage id="of" /> {state.count} <FormattedMessage id="register" />
      </Grid>
    </React.Fragment>
  );
}